module.exports = __webpack_public_path__ + "img/cecilia-bolan-byn.e4af2871.jpg";